import Parse from "parse";

export function confirmDevicePairing(
  pairingRequestId,
  confirmingDeviceJID,
  confirmingPairingType
) {
  return Parse.Cloud.run("confirmDevicePairing", {
    pairingRequestId,
    confirmingDeviceJID,
    confirmingPairingType
  });
}
